module.exports = __webpack_public_path__ + "img/fashion_10.8a92ef8c.jpg";